export class JudgeForm {
    creationDate: string
    isConflict: boolean
    isVolunteeredBefore: boolean
    volunteerExperience: string
    isJudgedBefore: boolean
    judgedTournaments: string
    isProgramming: boolean
    programmingLanguages: string
    judgeExplanation: string
    reference: string
    additionalThoughts: string
    firstEvent: boolean
    secondEvent: boolean
    thirdEvent: boolean
    fourthEvent: boolean
    fifthEvent: boolean
    sixthEvent: boolean
}